import { Injectable } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';

@Injectable({
  providedIn: 'root'
})
export class IdempotencyService {
  public async generateDeterministicKey(
    url: string,
    method: string,
    body: unknown,
    userId: string | undefined
  ): Promise<string> {
    const payload = {
      url,
      method,
      body: this.serializeBody(body),
      userId: userId ?? 'anonymous'
    };

    const jsonString = JSON.stringify(payload);
    const encoder = new TextEncoder();
    const data = encoder.encode(jsonString);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');

    return hashHex;
  }

  public generateUuidKey(): string {
    return uuidv4();
  }

  public isJsonOrScalar(body: unknown): boolean {
    if (body === null || body === undefined) {
      return true;
    }

    if (body instanceof FormData ||
        body instanceof Blob ||
        body instanceof File ||
        body instanceof ArrayBuffer ||
        body instanceof Uint8Array) {
      return false;
    }

    return true;
  }

  private serializeBody(body: unknown): string {
    if (body === null || body === undefined) {
      return '';
    }

    if (typeof body === 'string') {
      return body;
    }

    if (typeof body === 'number' || typeof body === 'boolean') {
      return String(body);
    }

    try {
      return JSON.stringify(body, this.sortObjectKeys);
    } catch {
      return String(body);
    }
  }

  private sortObjectKeys(key: string, value: unknown): unknown {
    if (value && typeof value === 'object' && !Array.isArray(value)) {
      return Object.keys(value)
        .sort()
        .reduce((sorted, key) => {
          sorted[key] = (value as Record<string, unknown>)[key];
          return sorted;
        }, {} as Record<string, unknown>);
    }
    return value;
  }
}
